import { createSelector } from "@ngrx/store";

import * as sharedSelectors from "./shared.selectors";

export const selectSpinner = createSelector(
  sharedSelectors.selectFeatureRevisionState,
  (state) => state.spinner
);

export const selectIsSpinnerActive = createSelector(
  selectSpinner,
  (state) => state.pageActive > 0
);
